import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useApi } from "./use-api.ts";

type PreSignedUrl = {
  url: string;
};

export const usePreSignedUrl = (
  path: string,
  opts?: Omit<UseQueryOptions<PreSignedUrl>, "queryKey" | "queryFn">,
) => {
  const { callApi } = useApi<PreSignedUrl>();

  return useQuery({
    queryKey: ["__custom__", "pre-signed-url", path],
    queryFn: async () =>
      callApi("/pre-signed-url", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          path,
        }),
      }),
    ...opts,
  });
};
